import { Values, Errors, Locales } from './types';
import useEmailValidation from './useEmailValidation';
import useLoginValidation from './useLoginValidation';
import usePasswordValidation from './usePasswordValidation';
import useSignupCodeValidation from './useSignupCodeValidation';

const useFormValidation = (values: Values, locales: Locales): [boolean, boolean, boolean, boolean, Errors] => {
  const [isEmailValidOnServer, isEmailValidating, emailErrors] = useEmailValidation(values);
  const [isLoginValidOnServer, isLoginValidating, loginErrors] = useLoginValidation(values, locales);
  const [isSignupCodeValidOnServer, isSignupCodeValidating, signupCodeErrors] = useSignupCodeValidation(values);
  const [isPasswordValid, passwordErrors] = usePasswordValidation(values, locales);

  const isValid =
    isEmailValidOnServer &&
    isLoginValidOnServer &&
    isSignupCodeValidOnServer &&
    isPasswordValid &&
    !!values.currency.length &&
    !!values.country.length &&
    values.terms &&
    values.adult;

  return [
    isValid,
    isEmailValidating,
    isLoginValidating,
    isSignupCodeValidating,
    { ...emailErrors, ...loginErrors, ...signupCodeErrors, ...passwordErrors },
  ];
};

export default useFormValidation;
